import { FC, useCallback } from 'react';
import summaryClass from '../../assets/scss/SubscriptionDetail/Summary.module.scss';
import { DeliverySummarySection } from './DeliverySummarySection';
import { SummaryViewType } from '../../types/view/SummaryViewType';
import { postMessageGtag } from '../../utils/trackClick';

export const Summary: FC<{
  summary?: SummaryViewType;
  isDeliveryTimeSetting: boolean;
  clickDeliveryDateFunc: () => void;
  clickDeliveryIntervalFunc: () => void;
  clickSkipLinkFunc: () => void;
  clickNewOrderFunc: () => void;
  loading: boolean;
}> = ({
  summary,
  isDeliveryTimeSetting,
  clickDeliveryDateFunc,
  clickDeliveryIntervalFunc,
  clickSkipLinkFunc,
  clickNewOrderFunc,
  loading,
}) => {
  const clickSkipLinkHandler = useCallback(() => {
    if (loading) return;

    clickSkipLinkFunc();
  }, [clickSkipLinkFunc, loading]);

  if (!summary) return <></>;

  // GAタグ
  const suffix = isDeliveryTimeSetting ? 'pack' : 'packet';
  const eventCategory = 'detailCalender';
  const eventName_openModalDate = 'click_modal_open_date_' + suffix;
  const eventName_openModalInterval = 'click_modal_open_period';
  const eventName_openModalNewOrder = 'click_modal_open_OrderNow';
  const eventName_openModalSkip = 'click_modal_open_skip';

  return (
    <div className={summaryClass.summaryContainer}>
      <h2 className={summaryClass.title}>お届け予定日</h2>
      <div className={summaryClass.detailContainer}>
        <DeliverySummarySection
          summary={summary}
          isDeliveryTimeSetting={isDeliveryTimeSetting}
          clickDeliveryDateFunc={() => {
            clickDeliveryDateFunc();
            postMessageGtag(eventName_openModalDate, eventCategory);
          }}
          clickDeliveryIntervalFunc={() => {
            clickDeliveryIntervalFunc();
            postMessageGtag(eventName_openModalInterval, eventCategory);
          }}
        />
        <div
          className={summaryClass.newOrder}
          onClick={() => {
            clickNewOrderFunc();
            postMessageGtag(eventName_openModalNewOrder, eventCategory);
          }}
        >
          最短でお届け
        </div>
        <div
          className={summaryClass.skipLink}
          onClick={() => {
            clickSkipLinkHandler();
            postMessageGtag(eventName_openModalSkip, eventCategory);
          }}
        >
          次回お届けをスキップ
        </div>
      </div>
    </div>
  );
};
